module.exports = __webpack_public_path__ + "static/media/settings.a7654f91.svg";